export default {
  computationalThinking: 'Pensamiento computacional',
  teachersTraining: 'Acompañamiento docente',
  globalCitizenship: 'Ciudadanía global',
  entrepreneurialSpirit: 'Espíritu emprendedor',
  analysis: 'Análisis',
  communication: 'Comunicación',
  creativity: 'Creatividad',
  criticalThinking: 'Pensamiento crítico',
  flexibility: 'Flexibilidad',
  initiative: 'Iniciativa',
  leadership: 'Liderazgo',
  perseverance: 'Perseverancia',
  problemResolution: 'Resolución de problemas',
  resilience: 'Resiliencia',
  responsibility: 'Responsabilidad',
  teamwork: 'Trabajo en equipo',
  ods: {
    noPoverty: 'Fin de la pobreza',
    zeroHunger: 'Hambre cero',
    goodHealthAndWellBeing: 'Salud y bienestar',
    qualityEducation: 'Educación de calidad',
    genderEquality: 'Igualdad de género',
    cleanWaterAndSanitation: 'Agua limpia y saneamiento',
    affordableAndCleanEnergy: 'Energía asequible y no contaminante',
    decentWorkAndEconomicGrowth: 'Trabajo decente y crecimiento económico',
    industryInnovationAndInfrastructure: 'Industria, innovación e infraestructura',
    reducedInequality: 'Reducción de las desigualdades',
    sustainableCitiesAndCommunities: 'Ciudades y comunidades sostenibles',
    responsibleConsumptionAndProduction: 'Producción y consumo responsables',
    climateAction: 'Acción por el clima',
    lifeBelowWater: 'Vida submarina',
    lifeOnLand: 'Vida de ecosistemas terrestres',
    peaceJusticeAndStrongInstitutions: 'Paz, justicia e instituciones sólidas',
    partnershipForTheGoals: 'Alianzas para lograr los objetivos'
  }
}

export const en = {
  computationalThinking: 'Computational thinking',
  teachersTraining: 'Teacher guidance',
  globalCitizenship: 'Global citizenship',
  entrepreneurialSpirit: 'Entrepreneurial spirit',
  analysis: 'Analysis',
  communication: 'Communication',
  creativity: 'Creativity',
  criticalThinking: 'Critical thinking',
  flexibility: 'Flexibility',
  initiative: 'Initiative',
  leadership: 'Leadership',
  perseverance: 'Perseverance',
  problemResolution: 'Problem resolution',
  resilience: 'Resilience',
  responsibility: 'Responsibility',
  teamwork: 'Team work',
  ods: {
    noPoverty: 'No poverty',
    zeroHunger: 'Zero hunger',
    goodHealthAndWellBeing: 'Good health and well-being',
    qualityEducation: 'Quality education',
    genderEquality: 'Gender equality',
    cleanWaterAndSanitation: 'Clean water and sanitation',
    affordableAndCleanEnergy: 'Affordable and clean energy',
    decentWorkAndEconomicGrowth: 'Decent work and economic growth',
    industryInnovationAndInfrastructure: 'Industry, Innovation and Infrastructure',
    reducedInequality: 'Reduced inequality',
    sustainableCitiesAndCommunities: 'Sustainable cities and communities',
    responsibleConsumptionAndProduction: 'Responsible consumption and production',
    climateAction: 'Climate action',
    lifeBelowWater: 'Life below water',
    lifeOnLand: 'Life on land',
    peaceJusticeAndStrongInstitutions: 'Peace, justice and strong institutions',
    partnershipForTheGoals: 'Partnership for the goals'
  }
}

export const ca = {
  computationalThinking: 'Pensament computacional',
  teachersTraining: 'Acompanyament docent',
  globalCitizenship: 'Ciutadania global',
  entrepreneurialSpirit: 'Esperit emprenedor',
  analysis: 'Anàlisi',
  communication: 'Comunicació',
  creativity: 'Creativitat',
  criticalThinking: 'Pensament crític',
  flexibility: 'Flexibilitat',
  initiative: 'Iniciativa',
  leadership: 'Lideratge',
  perseverance: 'Perseverança',
  problemResolution: 'Resolució de problemes',
  resilience: 'Resiliència',
  responsibility: 'Responsabilidad',
  teamwork: 'Treball en equip',
  ods: {
    noPoverty: 'Fi de la pobresa',
    zeroHunger: 'Fam zero',
    goodHealthAndWellBeing: 'Salut i benestar',
    qualityEducation: 'Educació de qualitat',
    genderEquality: 'Igualtat de génere',
    cleanWaterAndSanitation: 'Aigua neta y sanejament',
    affordableAndCleanEnergy: 'Energia neta i assequible',
    decentWorkAndEconomicGrowth: 'Treball digne i crexement econòmic',
    industryInnovationAndInfrastructure: 'Indústria innovació infraestructures',
    reducedInequality: 'Reducció de les desigualtats',
    sustainableCitiesAndCommunities: 'Ciutats y comunitats sostenibles',
    responsibleConsumptionAndProduction: 'Consum y producció responsables',
    climateAction: 'Acció climàtica',
    lifeBelowWater: 'Vida submarina',
    lifeOnLand: 'Vida terrestre',
    peaceJusticeAndStrongInstitutions: 'Pau, justícia i institucions sòlides',
    partnershipForTheGoals: 'Aliança pels objectius'
  }
}
